__turbopack_context__.v({
  "className": "archivo_4ebb4d9b-module__n77mHG__className",
});
